
// GENERAL CONSTANTS
export const FETCH_USER_DATA = "FETCH_USER_DATA";
export const HEADER_STATUS = "HEADER_STATUS";
export const MINI_MENU = "MINI_MENU";
export const INSUREDEQUALPOLICYHOLDER = "INSUREDEQUALPOLICYHOLDER";
export const INQUERY = "INQUERY";
export const UNITLINKDATA = "UNITLINKDATA";
export const UNIUVERSALDATA = "UNIUVERSALDATA";